import IconButton from '@mui/material/IconButton';
import { format } from 'date-fns';
import * as React from 'react';
import { CgSpinner } from 'react-icons/cg';
import { GrDocumentDownload } from 'react-icons/gr';
import { toast } from 'react-toastify';
import { downloadFile } from '@/utils/downloadFile';
import LightTooltip from './LightTooltip';

export const OffShiftTripsExtractionButton: React.FC = () => {
	const [loading, setLoading] = React.useState(false);
	const formattedDate = format(new Date(), 'dd-MM-yyyy');

	async function extractOffShiftTrips() {
		setLoading(true);
		try {
			downloadFile(
				'/extraction/off-shift-trips',
				`Para liberação da catraca - SGFT - ${formattedDate}.xlsx`,
			);
		} catch (e) {
			toast.error('Estrutura sem dados', {
				theme: 'colored',
				toastId: 'error',
			});
			throw e;
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className="cursor-pointer ">
			<LightTooltip title="Extrair liberações da catraca">
				<span>
					<IconButton onClick={extractOffShiftTrips} disabled={loading}>
						{loading ? (
							<CgSpinner
								size={30}
								color="#c1c1c1"
								className="h-full animate-spin"
							/>
						) : (
							<GrDocumentDownload />
						)}
					</IconButton>
				</span>
			</LightTooltip>
		</div>
	);
};
